import styled from "styled-components";

const RecipientScrollDiv = styled.div`
  padding: 0 4px;
  &::-webkit-scrollbar-track {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.palette.light.c300};
  }
  overflow: scroll;
  overflow-x: hidden;
`;
export default RecipientScrollDiv;
